module.exports = __webpack_public_path__ + "static/media/watermark-right-preview.c896e960.png";